<template>
	<footer class="footer">
		<div class="footer__inner _cnt">
			<nav class="footer__nav nav">
				<ul class="nav__list">
					<li class="nav__item">
						<router-link
							class="nav__link _header-link"
							:class="{ nav__link_active: $route.path === '/' }"
							to="/"
							>{{ $t('Home') }}</router-link
						>
					</li>
					<li class="nav__item">
						<router-link
							class="nav__link _header-link"
							:class="{
								nav__link_active: $route.path === '/products/all',
							}"
							:to="{
								name: 'ProductListPage',
								params: { itemType: 'all' },
							}"
							>{{ $t('Market') }}</router-link
						>
					</li>
					<li class="nav__item">
						<router-link
							class="nav__link _header-link"
							:class="{
								nav__link_active:
									$route.path === '/products/all?sale=true',
							}"
							to="/products/all?special_offers=sale"
							>{{ $t('Deals') }}</router-link
						>
					</li>
					<li class="nav__item" @click="sellSkin">
						<a class="nav__link _header-link">{{ $t('Sell skin') }}</a>
					</li>
				</ul>
			</nav>
			<div class="footer__items">
				<div class="footer__item footer__item_1">
					<div class="footer__company">
						<p class="footer__company-label">
							{{ requisitesParts.label }}
						</p>

						<p
							v-if="requisitesParts.companyNumber"
							class="footer__company-name"
						>
							<span>{{ $t('Company number') }}:</span>
							{{ requisitesParts.companyNumber }}
						</p>

						<p
							v-if="requisitesParts.legalAddress"
							class="footer__company-name"
						>
							<span>{{ $t('Legal address') }}:</span>
							{{ requisitesParts.legalAddress }}
						</p>

						<p
							v-if="requisitesParts.businessAddress"
							class="footer__company-name"
						>
							<span>{{ $t('Business address') }}:</span>
							{{ requisitesParts.businessAddress }}
						</p>
					</div>
				</div>
				<div class="footer__item footer__item_2">
					<router-link to="/" class="footer__logo">
						<svg
							width="187"
							height="40"
							viewBox="0 0 187 40"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clip-path="url(#clip0_51_1427)">
								<mask id="path-1-inside-1_51_1427" fill="white">
									<path
										d="M14.4739 0.727686C17.2795 -0.293423 20.3442 0.859705 21.8289 3.32458C21.8518 3.36251 21.9005 3.37616 21.9398 3.35573C22.0983 3.2733 22.2642 3.20066 22.4366 3.1379C24.561 2.36469 26.9104 3.46025 27.6836 5.58462C28.4567 7.70893 27.3609 10.0575 25.2366 10.8307C23.9269 11.3074 22.5324 11.0738 21.4739 10.3268C21.4377 10.3013 21.3877 10.3082 21.36 10.3427C20.6807 11.1901 19.7691 11.8688 18.674 12.2674C16.9497 12.895 15.1271 12.7015 13.6334 11.8872C13.5769 11.8564 13.507 11.8985 13.5064 11.9629C13.4955 13.2904 12.6731 14.5326 11.3522 15.0133C11.1143 15.0999 10.8727 15.1563 10.6316 15.1859C10.5814 15.192 10.5474 15.2409 10.5585 15.2903C10.8237 16.4766 10.1752 17.704 9.00243 18.131C7.72792 18.5949 6.31853 17.9375 5.85447 16.6631C5.39055 15.3885 6.04777 13.979 7.32239 13.5151C7.3397 13.5088 7.34775 13.4893 7.33915 13.473C7.26912 13.3405 7.20812 13.2011 7.15539 13.0563C6.53683 11.3568 7.41265 9.47712 9.11208 8.85851C9.64591 8.66422 10.1976 8.61793 10.7223 8.69788C10.7786 8.70645 10.8232 8.65167 10.8038 8.5982C9.64397 5.41165 11.2873 1.8875 14.4739 0.727686Z"
									/>
								</mask>
								<path
									d="M14.4739 0.727686C17.2795 -0.293423 20.3442 0.859705 21.8289 3.32458C21.8518 3.36251 21.9005 3.37616 21.9398 3.35573C22.0983 3.2733 22.2642 3.20066 22.4366 3.1379C24.561 2.36469 26.9104 3.46025 27.6836 5.58462C28.4567 7.70893 27.3609 10.0575 25.2366 10.8307C23.9269 11.3074 22.5324 11.0738 21.4739 10.3268C21.4377 10.3013 21.3877 10.3082 21.36 10.3427C20.6807 11.1901 19.7691 11.8688 18.674 12.2674C16.9497 12.895 15.1271 12.7015 13.6334 11.8872C13.5769 11.8564 13.507 11.8985 13.5064 11.9629C13.4955 13.2904 12.6731 14.5326 11.3522 15.0133C11.1143 15.0999 10.8727 15.1563 10.6316 15.1859C10.5814 15.192 10.5474 15.2409 10.5585 15.2903C10.8237 16.4766 10.1752 17.704 9.00243 18.131C7.72792 18.5949 6.31853 17.9375 5.85447 16.6631C5.39055 15.3885 6.04777 13.979 7.32239 13.5151C7.3397 13.5088 7.34775 13.4893 7.33915 13.473C7.26912 13.3405 7.20812 13.2011 7.15539 13.0563C6.53683 11.3568 7.41265 9.47712 9.11208 8.85851C9.64591 8.66422 10.1976 8.61793 10.7223 8.69788C10.7786 8.70645 10.8232 8.65167 10.8038 8.5982C9.64397 5.41165 11.2873 1.8875 14.4739 0.727686Z"
									fill="white"
								/>
								<path
									d="M14.4739 0.727686L14.3029 0.257837L14.3029 0.257839L14.4739 0.727686ZM22.4366 3.1379L22.2656 2.66805L22.4366 3.1379ZM27.6836 5.58462L28.1535 5.41364L28.1535 5.41361L27.6836 5.58462ZM25.2366 10.8307L25.4076 11.3006L25.2366 10.8307ZM18.674 12.2674L18.845 12.7372L18.845 12.7372L18.674 12.2674ZM11.3522 15.0133L11.5232 15.4832L11.5233 15.4832L11.3522 15.0133ZM9.00243 18.131L9.17344 18.6008L9.17347 18.6008L9.00243 18.131ZM5.85447 16.6631L5.38462 16.8341L5.38465 16.8342L5.85447 16.6631ZM7.32239 13.5151L7.15141 13.0453L7.15138 13.0453L7.32239 13.5151ZM7.15539 13.0563L6.68554 13.2273L6.68555 13.2273L7.15539 13.0563ZM9.11208 8.85851L8.94107 8.38867L8.94105 8.38867L9.11208 8.85851ZM10.8038 8.5982L10.3339 8.76921L10.3339 8.76923L10.8038 8.5982ZM7.33915 13.473L6.89706 13.7066L7.33915 13.473ZM10.6316 15.1859L10.5707 14.6896L10.6316 15.1859ZM10.5585 15.2903L11.0464 15.1812L10.5585 15.2903ZM13.6334 11.8872L13.3941 12.3263L13.6334 11.8872ZM13.5064 11.9629L13.0065 11.9588L13.5064 11.9629ZM10.7223 8.69788L10.647 9.19217L10.7223 8.69788ZM21.36 10.3427L20.9699 10.03L21.36 10.3427ZM21.8289 3.32458L22.2572 3.0666L21.8289 3.32458ZM21.9398 3.35573L21.7091 2.91213L21.9398 3.35573ZM14.4739 0.727686L14.6449 1.19753C17.2212 0.259881 20.0368 1.31835 21.4006 3.58257L21.8289 3.32458L22.2572 3.0666C20.6517 0.401062 17.3378 -0.846728 14.3029 0.257837L14.4739 0.727686ZM21.9398 3.35573L22.1705 3.79932C22.3089 3.72732 22.4548 3.66336 22.6076 3.60774L22.4366 3.1379L22.2656 2.66805C22.0736 2.73796 21.8876 2.81927 21.7091 2.91213L21.9398 3.35573ZM22.4366 3.1379L22.6076 3.60774C24.4725 2.92898 26.535 3.89075 27.2138 5.75563L27.6836 5.58462L28.1535 5.41361C27.2858 3.02975 24.6495 1.8004 22.2656 2.66805L22.4366 3.1379ZM27.6836 5.58462L27.2138 5.7556C27.8924 7.62032 26.9305 9.68209 25.0656 10.3609L25.2366 10.8307L25.4076 11.3006C27.7912 10.433 29.021 7.79754 28.1535 5.41364L27.6836 5.58462ZM25.2366 10.8307L25.0656 10.3609C23.9164 10.7791 22.6926 10.5749 21.7621 9.91831L21.4739 10.3268L21.1856 10.7354C22.3721 11.5726 23.9375 11.8356 25.4076 11.3006L25.2366 10.8307ZM21.36 10.3427L20.9699 10.03C20.3459 10.8083 19.5092 11.4312 18.5029 11.7975L18.674 12.2674L18.845 12.7372C20.029 12.3063 21.0154 11.5719 21.7501 10.6555L21.36 10.3427ZM18.674 12.2674L18.503 11.7975C16.9192 12.3739 15.2458 12.1967 13.8727 11.4482L13.6334 11.8872L13.3941 12.3263C15.0083 13.2062 16.9801 13.416 18.845 12.7372L18.674 12.2674ZM13.5064 11.9629L13.0065 11.9588C12.9972 13.0847 12.2994 14.1365 11.1812 14.5435L11.3522 15.0133L11.5233 15.4832C13.0468 14.9286 13.9938 13.4961 14.0064 11.967L13.5064 11.9629ZM11.3522 15.0133L11.1812 14.5435C10.9801 14.6167 10.7756 14.6644 10.5707 14.6896L10.6316 15.1859L10.6926 15.6821C10.9698 15.6481 11.2484 15.5832 11.5232 15.4832L11.3522 15.0133ZM10.5585 15.2903L10.0705 15.3994C10.2818 16.3442 9.76459 17.3214 8.83138 17.6612L9.00243 18.131L9.17347 18.6008C10.5859 18.0866 11.3657 16.609 11.0464 15.1812L10.5585 15.2903ZM9.00243 18.131L8.83142 17.6612C7.81647 18.0306 6.69391 17.507 6.32429 16.492L5.85447 16.6631L5.38465 16.8342C5.94315 18.3679 7.63938 19.1592 9.17344 18.6008L9.00243 18.131ZM5.85447 16.6631L6.32432 16.4921C5.95484 15.4769 6.47826 14.3544 7.4934 13.985L7.32239 13.5151L7.15138 13.0453C5.61727 13.6036 4.82625 15.3 5.38462 16.8341L5.85447 16.6631ZM7.33915 13.473L7.78123 13.2394C7.72277 13.1288 7.67083 13.0105 7.62522 12.8852L7.15539 13.0563L6.68555 13.2273C6.7454 13.3917 6.81546 13.5522 6.89706 13.7066L7.33915 13.473ZM7.15539 13.0563L7.62523 12.8853C7.10106 11.4451 7.84332 9.85245 9.2831 9.32835L9.11208 8.85851L8.94105 8.38867C6.98198 9.10179 5.9726 11.2685 6.68554 13.2273L7.15539 13.0563ZM9.11208 8.85851L9.28309 9.32836C9.7359 9.16355 10.2028 9.12449 10.647 9.19217L10.7223 8.69788L10.7976 8.20358C10.1925 8.11138 9.55591 8.16488 8.94107 8.38867L9.11208 8.85851ZM10.8038 8.5982L11.2736 8.42719C10.2083 5.50013 11.7178 2.2629 14.6449 1.19753L14.4739 0.727686L14.3029 0.257839C10.8568 1.5121 9.07968 5.32317 10.3339 8.76921L10.8038 8.5982ZM7.32239 13.5151L7.49336 13.985C7.7814 13.8802 7.93855 13.5372 7.78123 13.2394L7.33915 13.473L6.89706 13.7066C6.75696 13.4414 6.89801 13.1375 7.15141 13.0453L7.32239 13.5151ZM10.6316 15.1859L10.5707 14.6896C10.2231 14.7323 9.9959 15.0658 10.0705 15.3994L10.5585 15.2903L11.0464 15.1812C11.0989 15.416 10.9397 15.6518 10.6926 15.6821L10.6316 15.1859ZM13.6334 11.8872L13.8727 11.4482C13.4765 11.2323 13.01 11.526 13.0065 11.9588L13.5064 11.9629L14.0064 11.967C14.0039 12.271 13.6772 12.4806 13.3941 12.3263L13.6334 11.8872ZM10.7223 8.69788L10.647 9.19217C11.0808 9.25827 11.4222 8.83547 11.2736 8.42718L10.8038 8.5982L10.3339 8.76923C10.2242 8.46787 10.4764 8.15463 10.7976 8.20358L10.7223 8.69788ZM21.4739 10.3268L21.7621 9.91831C21.5119 9.74171 21.1643 9.78748 20.9699 10.03L21.36 10.3427L21.7501 10.6555C21.6111 10.8288 21.3635 10.8609 21.1856 10.7354L21.4739 10.3268ZM21.8289 3.32458L21.4006 3.58257C21.5601 3.84733 21.8977 3.9412 22.1705 3.79932L21.9398 3.35573L21.7091 2.91213C21.9033 2.81112 22.1434 2.8777 22.2572 3.0666L21.8289 3.32458Z"
									fill="#9F2C2C"
									mask="url(#path-1-inside-1_51_1427)"
								/>
								<path
									d="M17.4683 18.5951L16.1789 17.6476C16.1659 17.6381 16.156 17.6249 16.1504 17.6097L16.1089 17.4955C16.0934 17.453 16.1153 17.406 16.1578 17.3906L18.382 16.581C18.4244 16.5656 18.4464 16.5186 18.4309 16.4761L18.2457 15.9672C18.2302 15.9247 18.1832 15.9028 18.1407 15.9183L14.8705 17.1086C14.8543 17.1145 14.8404 17.1253 14.8309 17.1397C14.7799 17.2176 14.6094 17.4863 14.5462 17.6902C14.4375 18.0407 14.4071 18.278 14.5128 18.6294C14.5315 18.6915 14.5696 18.7854 14.5696 18.7854C14.7081 19.2751 13.5835 18.0557 13.5018 17.9667C13.4984 17.963 13.4959 17.9596 13.4933 17.9553C13.4565 17.8947 13.1714 17.4136 13.1708 17.065C13.1706 16.9382 13.1836 16.8669 13.2079 16.7424C13.2629 16.4619 13.4696 16.0844 13.5264 15.9843C13.5358 15.9677 13.5507 15.9555 13.5685 15.949L20.3021 13.4981C20.3165 13.4929 20.3319 13.4918 20.3467 13.4952C20.4931 13.529 21.3086 13.733 21.602 14.1508C21.7837 14.4093 21.8275 14.5992 21.8787 14.911C21.9191 15.1562 21.93 15.302 21.8896 15.5472C21.8175 15.9847 21.3638 16.5032 21.2336 16.6445C21.2123 16.6676 21.2056 16.7004 21.2163 16.7299L21.9369 18.7098C21.9524 18.7523 21.9305 18.7993 21.888 18.8147L18.2923 20.1235C18.2527 20.1379 18.2086 20.1199 18.1904 20.0819L17.4936 18.6258C17.4878 18.6136 17.4791 18.6031 17.4683 18.5951Z"
									fill="white"
									stroke="#9F2C2C"
									stroke-width="0.5"
								/>
								<path
									d="M27.4562 22.6375L16.5275 26.6152C16.474 26.6347 16.4174 26.595 16.4176 26.538L16.424 24.2281C16.4241 24.1989 16.4389 24.1724 16.4639 24.1574C16.6736 24.0307 17.6562 23.414 18.0094 22.7708C18.2524 22.3282 18.36 21.5767 18.3852 21.3767C18.3891 21.3457 18.4098 21.3198 18.4391 21.3091L22.63 19.7837C22.6419 19.7794 22.6545 19.7779 22.667 19.7794C22.8568 19.8022 24.4255 20.002 25.3121 20.4739C26.2321 20.9636 27.2288 22.1782 27.4931 22.5129C27.5272 22.5562 27.508 22.6186 27.4562 22.6375Z"
									fill="white"
									stroke="#9F2C2C"
									stroke-width="0.5"
								/>
								<path
									d="M30.5417 37.4465L23.8686 39.8753C23.8416 39.8852 23.8115 39.8801 23.7891 39.8621L20.761 37.4125C20.7115 37.3725 20.7247 37.2937 20.7845 37.2719L31.2309 33.4698C31.2907 33.448 31.3514 33.4999 31.3392 33.5624L30.5941 37.3853C30.5886 37.4134 30.5687 37.4367 30.5417 37.4465Z"
									fill="white"
									stroke="#9F2C2C"
									stroke-width="0.5"
								/>
								<path
									d="M31.2316 32.088L19.7658 36.2612C19.7295 36.2744 19.6884 36.2598 19.668 36.227C17.7491 33.1516 17.099 31.3281 16.6754 28.0068C16.6706 27.9689 16.6926 27.932 16.7285 27.919L28.1969 23.7448C28.2318 23.7321 28.2714 23.7451 28.2925 23.7757C30.2105 26.5512 30.8477 28.3875 31.2848 32.0005C31.2893 32.0383 31.2674 32.075 31.2316 32.088Z"
									fill="white"
									stroke="#9F2C2C"
									stroke-width="0.5"
								/>
								<circle
									cx="20.2989"
									cy="15.5256"
									r="0.736807"
									transform="rotate(-20 20.2989 15.5256)"
									fill="#9F2C2C"
								/>
							</g>
							<path
								d="M50.5341 17C50.4886 16.4318 50.2756 15.9886 49.8949 15.6705C49.5199 15.3523 48.9489 15.1932 48.1818 15.1932C47.6932 15.1932 47.2926 15.2528 46.9801 15.3722C46.6733 15.4858 46.446 15.642 46.2983 15.8409C46.1506 16.0398 46.0739 16.267 46.0682 16.5227C46.0568 16.733 46.0938 16.9233 46.179 17.0938C46.2699 17.2585 46.4119 17.4091 46.6051 17.5455C46.7983 17.6761 47.0455 17.7955 47.3466 17.9034C47.6477 18.0114 48.0057 18.108 48.4205 18.1932L49.8523 18.5C50.8182 18.7045 51.6449 18.9744 52.3324 19.3097C53.0199 19.6449 53.5824 20.0398 54.0199 20.4943C54.4574 20.9432 54.7784 21.4489 54.983 22.0114C55.1932 22.5739 55.3011 23.1875 55.3068 23.8523C55.3011 25 55.0142 25.9716 54.446 26.767C53.8778 27.5625 53.0653 28.1676 52.0085 28.5824C50.9574 28.9972 49.6932 29.2045 48.2159 29.2045C46.6989 29.2045 45.375 28.9801 44.2443 28.5312C43.1193 28.0824 42.2443 27.392 41.6193 26.4602C41 25.5227 40.6875 24.3239 40.6818 22.8636H45.1818C45.2102 23.3977 45.3438 23.8466 45.5824 24.2102C45.821 24.5739 46.1563 24.8494 46.5881 25.0369C47.0256 25.2244 47.5455 25.3182 48.1477 25.3182C48.6534 25.3182 49.0767 25.2557 49.4176 25.1307C49.7585 25.0057 50.017 24.8324 50.1932 24.6108C50.3693 24.3892 50.4602 24.1364 50.4659 23.8523C50.4602 23.5852 50.3722 23.3523 50.2017 23.1534C50.0369 22.9489 49.7642 22.767 49.3835 22.608C49.0028 22.4432 48.4886 22.2898 47.8409 22.1477L46.1023 21.7727C44.5568 21.4375 43.3381 20.8778 42.446 20.0938C41.5597 19.304 41.1193 18.2273 41.125 16.8636C41.1193 15.7557 41.4148 14.7869 42.0114 13.9574C42.6136 13.1222 43.446 12.4716 44.5085 12.0057C45.5767 11.5398 46.8011 11.3068 48.1818 11.3068C49.5909 11.3068 50.8097 11.5426 51.8381 12.0142C52.8665 12.4858 53.6591 13.1506 54.2159 14.0085C54.7784 14.8608 55.0625 15.858 55.0682 17H50.5341ZM57.1094 29V11.5455H61.848V18.6023H62.0866L67.3366 11.5455H72.8594L66.9616 19.3182L72.9957 29H67.3366L63.4162 22.4545L61.848 24.5V29H57.1094ZM79.0043 11.5455V29H74.2656V11.5455H79.0043ZM96.3523 11.5455V29H92.3977L86.0909 19.8295H85.9886V29H81.25V11.5455H85.2727L91.4773 20.6818H91.6136V11.5455H96.3523Z"
								fill="white"
							/>
							<path
								d="M108.003 17C107.957 16.4318 107.744 15.9886 107.364 15.6705C106.989 15.3523 106.418 15.1932 105.651 15.1932C105.162 15.1932 104.761 15.2528 104.449 15.3722C104.142 15.4858 103.915 15.642 103.767 15.8409C103.619 16.0398 103.543 16.267 103.537 16.5227C103.526 16.733 103.563 16.9233 103.648 17.0938C103.739 17.2585 103.881 17.4091 104.074 17.5455C104.267 17.6761 104.514 17.7955 104.815 17.9034C105.116 18.0114 105.474 18.108 105.889 18.1932L107.321 18.5C108.287 18.7045 109.114 18.9744 109.801 19.3097C110.489 19.6449 111.051 20.0398 111.489 20.4943C111.926 20.9432 112.247 21.4489 112.452 22.0114C112.662 22.5739 112.77 23.1875 112.776 23.8523C112.77 25 112.483 25.9716 111.915 26.767C111.347 27.5625 110.534 28.1676 109.477 28.5824C108.426 28.9972 107.162 29.2045 105.685 29.2045C104.168 29.2045 102.844 28.9801 101.713 28.5312C100.588 28.0824 99.7131 27.392 99.0881 26.4602C98.4688 25.5227 98.1563 24.3239 98.1506 22.8636H102.651C102.679 23.3977 102.813 23.8466 103.051 24.2102C103.29 24.5739 103.625 24.8494 104.057 25.0369C104.494 25.2244 105.014 25.3182 105.616 25.3182C106.122 25.3182 106.545 25.2557 106.886 25.1307C107.227 25.0057 107.486 24.8324 107.662 24.6108C107.838 24.3892 107.929 24.1364 107.935 23.8523C107.929 23.5852 107.841 23.3523 107.67 23.1534C107.506 22.9489 107.233 22.767 106.852 22.608C106.472 22.4432 105.957 22.2898 105.31 22.1477L103.571 21.7727C102.026 21.4375 100.807 20.8778 99.9148 20.0938C99.0284 19.304 98.5881 18.2273 98.5938 16.8636C98.5881 15.7557 98.8835 14.7869 99.4801 13.9574C100.082 13.1222 100.915 12.4716 101.977 12.0057C103.045 11.5398 104.27 11.3068 105.651 11.3068C107.06 11.3068 108.278 11.5426 109.307 12.0142C110.335 12.4858 111.128 13.1506 111.685 14.0085C112.247 14.8608 112.531 15.858 112.537 17H108.003ZM114.578 11.5455H120.476L124.533 21.4318H124.737L128.794 11.5455H134.692V29H130.055V18.9091H129.919L126.033 28.8636H123.237L119.351 18.8409H119.214V29H114.578V11.5455ZM153.847 20.2727C153.847 22.2159 153.469 23.8551 152.713 25.1903C151.957 26.5199 150.938 27.5284 149.653 28.2159C148.369 28.8977 146.938 29.2386 145.358 29.2386C143.767 29.2386 142.33 28.8949 141.045 28.2074C139.767 27.5142 138.75 26.5028 137.994 25.1733C137.244 23.8381 136.869 22.2045 136.869 20.2727C136.869 18.3295 137.244 16.6932 137.994 15.3636C138.75 14.0284 139.767 13.0199 141.045 12.3381C142.33 11.6506 143.767 11.3068 145.358 11.3068C146.938 11.3068 148.369 11.6506 149.653 12.3381C150.938 13.0199 151.957 14.0284 152.713 15.3636C153.469 16.6932 153.847 18.3295 153.847 20.2727ZM148.972 20.2727C148.972 19.2273 148.832 18.3466 148.554 17.6307C148.281 16.9091 147.875 16.3636 147.335 15.9943C146.801 15.6193 146.142 15.4318 145.358 15.4318C144.574 15.4318 143.912 15.6193 143.372 15.9943C142.838 16.3636 142.432 16.9091 142.153 17.6307C141.881 18.3466 141.744 19.2273 141.744 20.2727C141.744 21.3182 141.881 22.2017 142.153 22.9233C142.432 23.6392 142.838 24.1847 143.372 24.5597C143.912 24.929 144.574 25.1136 145.358 25.1136C146.142 25.1136 146.801 24.929 147.335 24.5597C147.875 24.1847 148.281 23.6392 148.554 22.9233C148.832 22.2017 148.972 21.3182 148.972 20.2727ZM156.039 29V11.5455H160.778V18.6023H161.016L166.266 11.5455H171.789L165.891 19.3182L171.925 29H166.266L162.346 22.4545L160.778 24.5V29H156.039ZM173.195 29V11.5455H185.775V15.3636H177.934V18.3636H185.127V22.1818H177.934V25.1818H185.741V29H173.195Z"
								fill="#9F2C2C"
							/>
							<defs>
								<clipPath id="clip0_51_1427">
									<rect width="40" height="40" fill="white" />
								</clipPath>
							</defs>
						</svg>
					</router-link>
					<div class="footer__links">
						<router-link
							v-for="page in staticPagesWithSlug"
							:key="page.id"
							:to="{ name: 'TextPage', params: { slug: page.slug } }"
							class="footer__link"
						>
							<span>{{ page.title }}</span>
						</router-link>
					</div>
				</div>
				<div class="footer__item footer__item_3">
					<p class="footer__label">
						{{ $t('Write us for any questions') }}:
					</p>
					<a
						:href="`mailto:${footerSupportEmail}`"
						class="footer__email"
						>{{ footerSupportEmail }}</a
					>
					<div class="footer__socials" v-if="socials.length">
						<a
							v-for="social in socials"
							:key="social.title + social.link"
							:href="social.link"
							target="_blank"
							rel="noopener noreferrer"
							class="footer__socials-link _ibg-contain"
						>
							<img :src="social.img" :alt="social.title" />
						</a>
					</div>
				</div>
			</div>
			<div class="footer__bottom">
				<p class="footer__rights">{{ footerCopyright }}</p>
				<div
					v-if="paymentMethodsList.length"
					class="footer__payment-methods"
				>
					<div
						v-for="method in paymentMethodsList"
						:key="method.code"
						class="footer__payment-method footer__payment-method_custom _ibg-contain"
					>
						<img :src="method.image" :alt="method.title" />
					</div>
				</div>
				<template v-else>
					<div class="footer__payment-methods">
						<div class="footer__payment-method _ibg-contain">
							<img src="@/assets/img/payment-methods/visa.svg" />
						</div>
						<div class="footer__payment-method _ibg-contain">
							<img src="@/assets/img/payment-methods/mastercard.svg" />
						</div>
					</div>
				</template>
			</div>
		</div>
	</footer>
</template>

<script>
import {
	COOKIE_PAGE,
	PRIVACY_PAGE,
	TERMS_PAGE,
} from '@/store/modules/staticPages';
import { mapState } from 'vuex';

export default {
	name: 'FooterComponent',
	props: {
		footerRequisites: {
			type: String,
		},
		footerSupportEmail: {
			type: String,
			required: true,
		},
		footerCopyright: {
			type: String,
			default: '',
		},
		paymentMethods: {
			type: [Object, Array],
		},
		isAuth: {
			type: Boolean,
		},
	},
	data() {
		return {
			socials: [],
		};
	},
	computed: {
		...mapState('staticPages', ['pages']),
		staticPages() {
			return this.pages || [];
		},
		staticPagesWithSlug() {
			return (this.pages || []).filter((page) => page && page.slug);
		},
		paymentMethodsList() {
			if (!this.paymentMethods) return [];
			return this.paymentMethods;
		},
		// allImages() {
		//   return this.paymentMethodsList.flatMap(this.getImages);
		// },
		requisitesParts() {
			if (!this.footerRequisites) {
				return {
					label: '',
					companyNumber: '',
					legalAddress: '',
					businessAddress: '',
				};
			}

			const lines = this.footerRequisites
				.split('\n')
				.map((l) => l.trim())
				.filter(Boolean);

			let label = '';
			let companyNumber = '';
			let legalAddress = '';
			let businessAddress = '';

			lines.forEach((line, index) => {
				const lower = line.toLowerCase();

				if (index === 0) {
					label = line;
				} else if (lower.startsWith('company number')) {
					companyNumber = line
						.replace(/company\s*number\s*:\s*/i, '')
						.trim();
				} else if (lower.startsWith('business address')) {
					businessAddress = line
						.replace(/business\s*address\s*:\s*/i, '')
						.trim();
				} else if (lower.startsWith('address')) {
					legalAddress = line.replace(/address\s*:\s*/i, '').trim();
				}
			});

			return {
				label,
				companyNumber,
				legalAddress,
				businessAddress,
			};
		},
	},
	created() {
		// Make constants available in template
		this.TERMS_PAGE = TERMS_PAGE;
		this.PRIVACY_PAGE = PRIVACY_PAGE;
		this.COOKIE_PAGE = COOKIE_PAGE;
	},
	mounted() {
		this.getSocials();
	},
	methods: {
		//getDefaultSocials() {
		//	return [
		//		{
		//			title: 'Facebook',
		//			link: 'https://www.facebook.com/',
		//			img: require('@/assets/img/face.svg'),
		//		},
		//		{
		//			title: 'Instagram',
		//			link: 'https://www.instagram.com/',
		//			img: require('@/assets/img/inst.svg'),
		//		},
		//	];
		//},
		sellSkin() {
			if (this.isAuth) {
				this.$emit('openSellSkinModal');
			} else {
				this.$emit('openSignIn');
			}
		},
		handleShopNowClick() {
			if (this.isAuth) {
				this.$router.push('/products/all');
			} else {
				this.$emit('openSignIn');
			}
		},
		getPageType(page) {
			if (page.is_terms === 1) return TERMS_PAGE;
			if (page.is_privacy === 1) return PRIVACY_PAGE;
			if (page.is_cookie === 1) return COOKIE_PAGE;
			return null;
		},
		// getImages(method) {
		//   const images = [];
		//   if (method.code === "card" || method.title === "Visa/Mastercard") {
		//     images.push(
		//       require("@/assets/img/methods/visa.svg"),
		//       require("@/assets/img/methods/mc_symbol.svg")
		//     );
		//   } else if (method.code === "eps" || method.title === "EPS") {
		//     images.push(require("@/assets/img/methods/eps.svg"));
		//   } else if (method.code === "trustly" || method.title === "Trustly") {
		//     images.push(require("@/assets/img/methods/trustly.svg"));
		//   } else if (method.code === "giropay" || method.title === "GiroPay") {
		//     images.push(require("@/assets/img/methods/giropay.svg"));
		//   } else if (method.code === "blik" || method.title === "Blik") {
		//     images.push(require("@/assets/img/methods/blik.svg"));
		//   } else if (method.code === "paidby" || method.title === "Paidby") {
		//     images.push(require("@/assets/img/methods/paidby.svg"));
		//   } else if (method.code === "klarna" || method.title === "Klarna") {
		//     images.push(require("@/assets/img/methods/klarna.svg"));
		//   } else if (
		//     method.code === "sofortuberweisung" ||
		//     method.title === "Sofortuberweisung"
		//   ) {
		//     images.push(require("@/assets/img/methods/sofortuber.svg"));
		//   } else if (method.code === "ideal" || method.title === "iDEAL") {
		//     images.push(require("@/assets/img/methods/ideal.svg"));
		//   } else if (
		//     method.code === "bancontact" ||
		//     method.title === "Bancontact"
		//   ) {
		//     images.push(require("@/assets/img/methods/bancontact.svg"));
		//   }
		//   return images;
		// },
		getSocials() {
			this.$http
				.get('social-links')
				.then((res) => {
					const payload = res?.data?.payload || [];
					if (Array.isArray(payload) && payload.length) {
						this.socials = payload;
					}
				})
				.catch(() => {});
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.footer {
	padding-top: 10px;
	padding-bottom: 20px;
	&__inner {
	}
	&__nav {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 35, 15);
		}
	}
	&__items {
		display: flex;
		gap: 20px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 35, 15);
		}
		@media (max-width: 649.98px) {
			flex-wrap: wrap;
		}
	}
	&__item {
		flex: 0 1 33.333%;
		&_1 {
			@media (max-width: 649.98px) {
				order: 2;
				flex: 0 1 calc(50% - 10px);
			}
			@media (max-width: $md5) {
				flex: 1 1 100%;
			}
		}
		&_2 {
			display: flex;
			flex-direction: column;
			align-items: center;
			@media (max-width: 649.98px) {
				order: 1;
				flex: 1 1 100%;
			}
		}
		&_3 {
			@media (max-width: 649.98px) {
				order: 3;
				flex: 0 1 calc(50% - 10px);
			}
			@media (max-width: $md5) {
				flex: 1 1 100%;
			}
		}
	}
	&__logo {
		display: inline-block;
		width: fit-content;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
		svg {
			path {
				transition: stroke 0.3s ease 0s;
			}
			stop {
				stop-color: var(--hint-primary-color);
				transition: stop-color 0.3s ease 0s;
			}
		}
		@media (any-hover: hover) {
			&:hover {
				svg {
					path {
						stroke: var(--hint-primary-color);
					}
					stop {
						stop-color: var(--hint-primary-color);
					}
				}
			}
		}
	}
	&__text {
		text-transform: uppercase;
		font-weight: 400;
		&:not(:last-child) {
			margin-bottom: 5px;
		}
	}
	&__company {
		font-weight: 400;

		&-label {
			&:not(:last-child) {
				margin-bottom: 7px;
			}
		}
		&-name {
			span {
				opacity: 0.7;
				color: var(--secondary-color);
			}
		}
	}
	&__links {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
	}
	&__link {
		padding: 7px 5px;
		display: block;
		font-weight: 400;
		transition: color 0.3s ease 0s;
		@media (any-hover: hover) {
			&:hover {
				color: var(--hint-color);
			}
		}
	}
	&__label {
		text-align: right;
		font-weight: 400;
	}
	&__email {
		padding: 5px 0px;
		display: flex;
		justify-content: flex-end;
		width: fit-content;
		margin-left: auto;
		color: var(--hint-color);
		transition: color 0.3s ease 0s;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
		@media (any-hover: hover) {
			&:hover {
				color: var(--hint-hover-color);
			}
		}
	}
	&__socials {
		display: flex;
		justify-content: flex-end;
		gap: 15px;
		&-link {
			flex: 0 0 24px;
			height: 24px;
		}
	}
	&__bottom {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		justify-content: space-between;
	}
	&__rights {
		opacity: 0.7;
		color: var(--secondary-color);
		font-weight: normal;
	}
	&__payment-methods {
		display: flex;
		gap: 10px;
	}
	&__payment-method {
		flex: 0 0 30px;
		width: 30px;
		min-width: 30px;
		height: 24px;
		&_custom {
			height: 24px !important;
			min-width: 74px !important;
			width: 74px !important;
			flex: 0 0 74px !important;
		}
	}
}

.nav {
	&__list {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
	}
	&__item {
	}
	&__link {
		cursor: pointer;
		pointer-events: auto;
		&_active {
			pointer-events: none;
			color: var(--hint-color);
			font-weight: 700;
			&::before {
				background-color: var(--primary-color);
			}
		}
	}
}
</style>
